<template>
  <el-container class="layout">
    <el-header>
      <header-vue></header-vue>
    </el-header>
    <el-main>
      <router-view v-if="!reload"></router-view>
    </el-main>
    <el-footer>
      <footer-vue></footer-vue>
    </el-footer>
  </el-container>
</template>

<script>
import FooterVue from "./component/FooterVue.vue";
import HeaderVue from "./component/HeaderVue";

export default {
  name: "layOut",
  components: {
    HeaderVue,
    FooterVue,
  },
  computed: {
    reload() {
      return this.$store.state.user.reload;
    },
  },
  async created() {
    if (this.$store.state.user.isLogin) {
      await this.$store.dispatch("getUserInfo");
    }
    this.$store.commit("RELOAD_PAGE", 1)
    this.$store.dispatch("getActiveDetail");
  },
};
</script>

<style lang="less" scoped >
/deep/ .el-main {
  min-height: calc(~"100vh - 130px");
  padding: 0;
  background-color: #f6f7f9;
}
/deep/ .el-header {
  background-color: #fff;
  position: sticky;
  z-index: 1000;
  top: 0;
  padding: 0 !important;
  box-shadow: 0px 0px 9px 0px rgba(124, 124, 124, 0.25);
}
/deep/ .el-footer {
  padding: 0 !important;
  height: auto !important;
}
</style>